$(document).ready(function() {

//               const deleteAllCookies = () => {
//               const cookies = document.cookie.split(";");

//               for (const cookie of cookies) {
//                 const eqPos = cookie.indexOf("=");
//                 const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
//                 document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
//               }
//             }

//             deleteAllCookies()

checkSession();

var order_banner = getCookie('order_banner');
if(order_banner == 'hide'){
}else{
  $('.as-banner').show();
}

  
if(window.matchMedia("(max-width: 767px)").matches){
  $('#pageheader .header-bar__search-input').on('click', function(e){
    $(this).removeClass('focus-visible'); 
    $(this).removeAttr('data-focus-visible-added');
    $('.top--search-bar').addClass('top--open'); 
    $('.top--search-bar').find(".search-form .header-bar__search-input").focus();
  });
}
var collection_banner = getCookie('collection_banner');
if(collection_banner == 'hide'){
  $('.collectionTopBanner').hide();
  $('.collectionChangesTemp .all_products').css("padding-top", "100px");
}else{
  $('.collectionTopBanner').show();
}
//   load_search_data();


  $('.fancybox-container').on('click', '.closeFancyBox', function(){
    console.log('click');
  });

  // $('.back_btn').on('click', function(e){
  //   e.preventDefault();
  //   var newLocation = $(this).attr('href');
  //   newPage();

  //   function newPage() 
  //   {
  //       if(newLocation == "javascript:history.back()")
  //       {
  //         history.back();
  //       }
  //       else
  //       {
  //          window.location = newLocation;
  //       }
  //   }
  // });

$(".productAjax").on('click', function(e){
  var $this = $(this);
  var title = $this.attr('data-title');
  e.preventDefault();
  //$('.all_products').addClass('loading');
  $('.template-collection .col-srch-rslt-txt').empty();
  var url = $(this).attr('href');
  var mainurl = $(this).data('url');


  $(".productAjax").removeClass('selected');
  $this.addClass('selected');
  

  $.ajax({
    type: 'GET',
    url: url+"?page=1",
    success: function(data) {
      if(title != "All")
      {
        var newurl = "window.location.href='"+mainurl+"'";
        $('.collectionHead .section-header__title').html(title+' <a onClick="'+newurl+'"><span class="cross-icon-btn"></span></a>');
        $('.collectionHead .section-header__title').removeClass('is-all');
      }
      else
      {
        $('.collectionHead .section-header__title').html(title);
        $('.collectionHead .section-header__title').addClass('is-all');
      }

      //         $('.all_products').empty();
      //$('.collectionChangesTemp').find("#more_div").empty();
      //here i changed all_product to ajaxinate
      $('#colDesktopTags').show();
      $('#AjaxinateContainer').html($(data).find('#AjaxinateContainer').html());

      //setTimeout(function(){
      if($(data).find('#AjaxinatePagination a').length>0){
        console.log($(data).find('#AjaxinatePagination a').attr('href'))

        var au = '<a href="'+$(data).find('#AjaxinatePagination a').attr('href')+'"><div class="loader-check"></div></a>';

        $('#AjaxinatePagination').html(au);
      }else{
        console.log('make blank')
        $('#AjaxinatePagination').html('');
      }
      //}, 1000);



      //$('.all_products').removeClass('loading');
      history.pushState('','',url);
console.log('gg')
      //var endlessScroll = new Ajaxinate();


      $("html, body").animate({ 
        scrollTop: 0
      }, "fast");
      //return false;


      $("#SortBy option[value='best-selling']").prop('selected', true);
      $('select.customSelect').css('width', '122px')

      //document.location.href="#shopify-section-header";
      //history.pushState('','',url);
          if (document.body.classList.contains('template-collection')) { 
          
            // document.querySelectorAll('.hidden-content-fancy').forEach(function(element) {
          //   element.addEventListener('scroll', function() {
          //     console.log('hhh');
          //     if (element.scrollHeight - element.scrollTop === element.clientHeight) {
          //       // alert("End");
          //       element.querySelector('.sticky-add-to-cart').classList.remove('active');
          //     }else{
          //       // element.querySelector('.sticky-add-to-cart').classList.add('active');
          //     }
          // });
          // });
          
            document.querySelectorAll('.hidden-content-fancy').forEach(function(element) {
              let lastScrollTop = 0;
            
              element.addEventListener('scroll', function() {
                let st = element.scrollTop;
            
                if (st > lastScrollTop) {
                  // Scrolling down
                  // console.log('Scrolling down');
                } else {
                  // Scrolling up
                  // console.log('Scrolling up');
                  element.querySelector('.sticky-add-to-cart').classList.add('active');
                }
            
                lastScrollTop = st;
            
                if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                  // Reached the end of the bottom
                  // alert('hh');
                  element.querySelector('.sticky-add-to-cart').classList.remove('active');
                }
              });
          
                  // For touch events on mobile
                element.addEventListener('touchmove', function() {
                  // Check if scrolled to the bottom
                  if (isElementAtBottom(element)) {
                    // Reached the end of the bottom
                    element.querySelector('.sticky-add-to-cart').classList.remove('active');
                  }
                });

                   //for mobile
                let startY;
                
                element.addEventListener('touchstart', function (e) {
                  startY = e.touches[0].clientY;
                });
                
                element.addEventListener('touchmove', function (e) {
                  let currentY = e.touches[0].clientY;
                
                  if (currentY > startY) {
                    // Scrolling down
                    // alert('Scrolling down');
                    element.querySelector('.sticky-add-to-cart').classList.add('active');
                  } else if (currentY < startY) {
                    // Scrolling up
                    // alert('Scrolling up');
                  }
                
                  startY = currentY;
                });
            });
           
          // Function to check if an element is scrolled to the bottom
          function isElementAtBottom(element) {
            return element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
          }
          
          
          }

    }
  });
});

//  get quantity onchange print it next to price
// $('#ProductSelect-0').change(function(){
//    var value = $('#ProductSelect-0 :selected').val();
//    $("#asQuantity").html(value);
// });

//   start get .load_venimg
$('.load_venimg').each(function(){
  var vendr = $(this).data('vendor');
  vendr = vendr.trim();
  var src = $('.vendors_list .vendor[data-vendor="'+vendr+'"]').attr('data-image');
  $(this).attr('src', src);
});
//  end get .load_venimg  

$(function() {
  if(typeof(theme.strings)!=='undefined'){
    $('#SortBy')
    .val(theme.strings.sortBy)
    .bind('change', function() {
      Shopify.queryParams.sort_by = $(this).val();
      var search_url = $.param(Shopify.queryParams);
      var current_url = window.location.href;
      if(current_url.indexOf('?') >= 0){
        current_url = current_url.split('?')[0];
      }
      var current_url = current_url+"?"+search_url;


      $('.all_products').addClass('loading');
      $('.template-collection .col-srch-rslt-txt').empty();
      var url = current_url;
      $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
          //alert(data);
          $('.collectionChangesTemp').find("#more_div").empty();
          //$('.all_products').html($(data).find('.all_products').html());

          $('#AjaxinateContainer').html($(data).find('#AjaxinateContainer').html());

          setTimeout(function(){
            if($(data).find('#AjaxinatePagination a').length>0){
              console.log($(data).find('#AjaxinatePagination a').attr('href'))

              var au = '<a href="'+$(data).find('#AjaxinatePagination a').attr('href')+'"><div class="loader-check"></div></a>';

              $('#AjaxinatePagination').html(au);
            }else{
              console.log('make blank')
              $('#AjaxinatePagination').html('');
            }
          }, 2000);

          $('.all_products').removeClass('loading');
          history.pushState('','',url);
          //var endlessScroll = new Ajaxinate();


       if (document.body.classList.contains('template-collection')) { 
            // document.querySelectorAll('.hidden-content-fancy').forEach(function(element) {
          //   element.addEventListener('scroll', function() {
          //     console.log('hhh');
          //     if (element.scrollHeight - element.scrollTop === element.clientHeight) {
          //       // alert("End");
          //       element.querySelector('.sticky-add-to-cart').classList.remove('active');
          //     }else{
          //       // element.querySelector('.sticky-add-to-cart').classList.add('active');
          //     }
          // });
          // });
          
            document.querySelectorAll('.hidden-content-fancy').forEach(function(element) {
              let lastScrollTop = 0;
            
              element.addEventListener('scroll', function() {
                let st = element.scrollTop;
            
                if (st > lastScrollTop) {
                  // Scrolling down
                  // console.log('Scrolling down');
                } else {
                  // Scrolling up
                  // console.log('Scrolling up');
                  element.querySelector('.sticky-add-to-cart').classList.add('active');
                }
            
                lastScrollTop = st;
            
                if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                  // Reached the end of the bottom
                  // alert('hh');
                  element.querySelector('.sticky-add-to-cart').classList.remove('active');
                }
              });
          
                  // For touch events on mobile
                element.addEventListener('touchmove', function() {
                  // Check if scrolled to the bottom
                  if (isElementAtBottom(element)) {
                    // Reached the end of the bottom
                    element.querySelector('.sticky-add-to-cart').classList.remove('active');
                  }
                });

                 //for mobile
                let startY;
                
                element.addEventListener('touchstart', function (e) {
                  startY = e.touches[0].clientY;
                });
                
                element.addEventListener('touchmove', function (e) {
                  let currentY = e.touches[0].clientY;
                
                  if (currentY > startY) {
                    // Scrolling down
                    // alert('Scrolling down');
                    element.querySelector('.sticky-add-to-cart').classList.add('active');
                  } else if (currentY < startY) {
                    // Scrolling up
                    // alert('Scrolling up');
                  }
                
                  startY = currentY;
                });
            });
           
          // Function to check if an element is scrolled to the bottom
          function isElementAtBottom(element) {
            return element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
          }
          
          
          }
        }
      });
    });
  }
});

//   sortBy with respect to selected product in collection page
// $("body").on('change', "#SortBy", function(){

//   var $this = $(this);

//   $('#SortBy')
//         .val(theme.strings.sortBy)
//         .bind('change', function() {
//           Shopify.queryParams.sort_by = $(this).val();
//           location.search = $.param(Shopify.queryParams);
//         });
//   });

$(window).scroll(function(){
  // console.log('hhhh');
  if ($(window).scrollTop() >= 50) {
    $('.template-collection .site-header').addClass('fixed-header');
    $('.template-collection .header-bar').addClass('fixed-header');
    $('#collectionSideMenu').css("padding-top", "100px");
    $('.collectionTopBanner').css("padding-top", "100px");
    $(".mb_nav").css("margin-bottom", "0");
  }
  else {
    $('.template-collection .site-header').removeClass('fixed-header');
    $('.template-collection .header-bar').removeClass('fixed-header');
    $('#collectionSideMenu').css("padding-top", "30px");
    $('.collectionTopBanner').css("padding-top", "30px");
    $('.followTop').css("padding-top", "0px");
  }
});

$('body').on('click', '.product-template .swiper-slide a', function(e) {
  e.preventDefault();
  $(this).parents('.swiper-slide').siblings('.swiper-slide').removeClass('active');
  $(this).parents('.swiper-slide').addClass('active');

  var dataDesktopImage = $(this).attr('data-desktop-image');
  var dataMobileImage = $(this).attr('data-mobile-image');
  var src = $(this).attr('href');

  var activeImage = window.matchMedia("(max-width: 767px)").matches
    ? dataMobileImage
    : dataDesktopImage;

  $('.product-template .main_featured_image img').eq(0).attr('src', activeImage);
  $('.product-template .main_featured_image img').eq(1).attr('src', src);

  setTimeout(function() {
    $('#zoom-1').trigger('zoom.destroy');
    $('#zoom-1').zoom({
      url: activeImage
    });
  }, 200);
});



$(document).on("click", ".quick_view .swiper-slide a", function(e){
  e.preventDefault();
  $(this).parents('.swiper-slide').siblings('.swiper-slide').removeClass('active');
  $(this).parents('.swiper-slide').addClass('active');
  var src = $(this).attr('href');
  var data_desktop_image = $(this).attr('data-desktop-image');
  var data_mobile_image = $(this).attr('data-mobile-image');

  // console.log(src, data_image);
  
  $(this).parents('.quickview').find('.quick_view .main_featured_image img').eq(0).attr('src', src);
  $(this).parents('.quickview').find('.quick_view .main_featured_image .enable_quick_view_zoom').attr('data-zoom-desktop', data_desktop_image);
  $(this).parents('.quickview').find('.quick_view .main_featured_image .enable_quick_view_zoom').attr('data-zoom-mobile', data_mobile_image);
var $zoom = $(this).parents('.quickview').find('.quick_view .enable_quick_view_zoom');
setTimeout(function() {
  $zoom.trigger('zoom.destroy');
  var zoomUrl = window.matchMedia("(max-width: 767px)").matches
    ? $zoom.attr('data-zoom-mobile')
    : $zoom.attr('data-zoom-desktop');
  $zoom.zoom({
    url: zoomUrl
  });
}, 200);
  
});
  // $('.fancybox-stage').on('click', function(e){
  //   console.log('hhhh')
  //   const container = document.querySelector('.fancybox-content');
  //   if (!container.contains(e.target)) {
  //     console.log('get it')
  //     document.body.classList.remove('fancybox-active');
  //     container_btn.click();
  //     // container.setAttribute('aria-hidden', 'true');
  //   }
  // });
if (document.body.classList.contains('template-collection')) { 
  // document.querySelectorAll('.hidden-content-fancy').forEach(function(element) {
//   element.addEventListener('scroll', function() {
//     console.log('hhh');
//     if (element.scrollHeight - element.scrollTop === element.clientHeight) {
//       // alert("End");
//       element.querySelector('.sticky-add-to-cart').classList.remove('active');
//     }else{
//       // element.querySelector('.sticky-add-to-cart').classList.add('active');
//     }
// });
// });

  document.querySelectorAll('.hidden-content-fancy').forEach(function(element) {
    let lastScrollTop = 0;
  
    element.addEventListener('scroll', function() {
      let st = element.scrollTop;
  
      if (st > lastScrollTop) {
        // Scrolling down
        // console.log('Scrolling down');
      } else {
        // Scrolling up
        // console.log('Scrolling up');
        element.querySelector('.sticky-add-to-cart').classList.add('active');
      }
  
      lastScrollTop = st;
  
      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
        // Reached the end of the bottom
        // alert('hh');
        element.querySelector('.sticky-add-to-cart').classList.remove('active');
      }
    });

        // For touch events on mobile
      // let startY;
      
      // element.addEventListener('touchstart', function (e) {
      //     startY = e.touches[0].clientY;
      // });
      
      // element.addEventListener('touchmove', function (e) {
      //     let currentY = e.touches[0].clientY;
          
      //     if (currentY > startY) {
      //     // Scrolling down
      //     console.log('Scrolling down');
      //     } else if (currentY < startY) {
      //     // Scrolling up
      //     console.log('Scrolling up');
      //     }
          
      //     startY = currentY;
      // });

      element.addEventListener('touchmove', function() {
        // Check if scrolled to the bottom
        if (isElementAtBottom(element)) {
          // Reached the end of the bottom
          element.querySelector('.sticky-add-to-cart').classList.remove('active');
        }
      });


       //for mobile
        let startY;
        
        element.addEventListener('touchstart', function (e) {
          startY = e.touches[0].clientY;
        });
        
        element.addEventListener('touchmove', function (e) {
          let currentY = e.touches[0].clientY;
        
          if (currentY > startY) {
            // Scrolling down
            // alert('Scrolling down');
            element.querySelector('.sticky-add-to-cart').classList.add('active');
          } else if (currentY < startY) {
            // Scrolling up
            // alert('Scrolling up');
          }
        
          startY = currentY;
        });
  });
 
// Function to check if an element is scrolled to the bottom
function isElementAtBottom(element) {
  return element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
}


}
// if (document.body.classList.contains('template-collection')) {
//   document.addEventListener('mouseup', function(e) {
//     console.log('hhhh')
//     const container = document.querySelector('.fancybox-content');
//     const container_btn = document.querySelector('[data-fancybox-close]');
//     if (!container.contains(e.target)) {
//       console.log('get it')
//       document.body.classList.remove('fancybox-active');
//       container_btn.click();
//       // container.setAttribute('aria-hidden', 'true');
//     }
//   });
// }

var src = $('.template-collection').find('.collectionSideInfo img').attr('src');
//   console.log(src);
$('.template-collection').find('.col_store_img').attr('src', src);

$('.template-collection .mobile-nav-trigger').click(function(){
  $('.mb_nav #MobileNav').slideToggle();
});

//   var base_url = "https://phpstack-606044-2163093.cloudwaysapps.com";
var base_url = "https://phpstack-711164-2355937.cloudwaysapps.com";
var cart_data = '';

//   as-forget-pass-form

$(document).on("submit", ".as-forget-pass-form form", function(e) {
  e.preventDefault();
  var $this = $(this);
  $.ajax({
    type: $this.attr('method'),
    url: $this.attr('action'),
    data: $this.serialize(),
    dataType: 'html',
    async: true,
    success: function(data) {
      if(data){
        $('.as-hidefor-login').toggle();
        $('.as-email_send_message').css("display","block");
        $('.as-hideon-forget').css("display","block");
      }
    },
    error: function(data, error){
      $('.as-hidefor-login').toggle();
      $('.as-email_send_message').html("There is something wrong with your email.")
      $('.as-email_send_message').css("display","block");
      $('.as-hideon-forget').css("display","block");
    }
  });
});

//  add ajax for login jquery start 
$(document).on("submit", ".ajax_form_login form", function(e) {
  e.preventDefault();
  var $this = $(this);
  //     $this.find(".as_fload").addClass("btn--loading");
  $this.find(".loader-check").css("display","block");
  $this.find(".btn span").css("visibility","hidden");
  $.ajax({
    type: $this.attr('method'),
    url: $this.attr('action'),
    data: $this.serialize(),
    dataType: 'html',
    async: true,
    success: function(html) {
      if (html.indexOf('Incorrect email or password.') !== -1) {
        $this.find('.errors').html('Incorrect email or password');
        $this.find('.errors').show();
        //           $this.find(".btn").removeClass("loader-check");
        $this.find(".loader-check").css("display","none");
        $this.find(".btn span").css("visibility","visible");
        //           $this.find(".as_fload").removeClass("btn--loading");          
        console.log('error');
      } else {
        $this.find('.errors').hide();
        initateCheckout();
        console.log('success');
      }
    },
    error: function(data, error){
      //         $this.removeClass("btn--loading");
      //         $this.find(".btn").removeClass("loader-check");
      $this.find(".loader-check").css("display","none");
      $this.find(".btn span").css("visibility","visible");
      $this.find('.errors').show();
      $this.find('.errors').html('Something went wrong, please try again later');
    }
  });
});

  $(document).on("submit", ".ajax_form_zipcode form", function(e) {
  e.preventDefault();
  var $this = $(this);
  $this.find(".loader-check").css("display","block");
  $this.find(".btn span").css("visibility","hidden");
  $.ajax({
    type: $this.attr('method'),
    url: "https://phpstack-711164-2355937.cloudwaysapps.com"+$this.attr('action'),
    data: $this.serialize(),
    dataType: 'json',
    async: true,
    success: function(data) {
      var status = data.status;
      if(status == 'true'){
        window.location.href = "/checkout";
      }else{
           $this.find(".loader-check").css("display","none");
            $this.find(".btn span").css("visibility","visible");
            $this.find('.errors').show();  
      }
      
    },
    error: function(data, error){
      $this.find(".loader-check").css("display","none");
      $this.find(".btn span").css("visibility","visible");
      $this.find('.errors').show();
      $this.find('.errors').html('Something went wrong, please try again later');
    }
  });
});

// $('[data-fancybox]').fancybox({
//   openEffect  : 'none',
//   closeEffect : 'none',
//   nextEffect  : 'none',
//   prevEffect  : 'none',
//   animationEffect: "none", // Set animation effect to "none"
//   transitionEffect: "none"
// });


//  add ajax for signup jquery start 
$(document).on("submit", ".ajax_form_signup form", function(e) {
  e.preventDefault();
  var $this = $(this);
  //     $this.find(".as_fload").addClass("btn--loading");
  //     $this.find(".btn").addClass("loader-check");
  $this.find(".loader-check").css("display","block");
  $this.find(".btn span").css("visibility","hidden");
  $.ajax({
    type: $this.attr('method'),
    url: $this.attr('action'),
    data: $this.serialize(),
    dataType: 'html',
    async: true,
    success: function(html) {
      var message = '';
      if (html.indexOf('email is invalid') !== -1) {
        message = "Email is invalid";
      } else if (html.indexOf('email can&#39;t be blank') !== -1) { 
        message = "Email can't be blank";
      } else if (html.indexOf('password can&#39;t be blank.') !== -1) {
        message = "Password can't be blank";
      }else if(html.indexOf('email address is already associated with an account') !== -1){
        message = 'This email address is already associated with an account. If this account is yours, you can reset your password';
      }else if(html.indexOf('Password is too short') !== -1){
        message = 'Password is too short (minimum is 5 characters)';
      }else{
        initateCheckout();
      }
      if(message){
        $this.find('.errors').html(message);
        $this.find('.errors').show();
        //           $this.find(".as_fload").removeClass("btn--loading"); 
        //           $this.find(".btn").removeClass("loader-check");
        $this.find(".loader-check").css("display","none");
        $this.find(".btn span").css("visibility","visible");
      }
      console.log(message);
    },
    error: function(data, error){
      $this.find('.errors').show();
      $this.find('.errors').html('Something went wrong, please try again later');
    }
  });
});

function initateCheckout(){
  $.ajax({
    type: "post",
    url: base_url +"/checkout",
    data: $('#cart_data').serialize(),
    success: function(data) {
      //         console.log(data);
      if( $('#discounted_url').val() == '') {
        window.location.href = data.invoice_url;
      }else{
        window.location.href = $('#discounted_url').val();
      }
    },
    error:function(){

    },
  });
}

//  add ajax for signup jquery end 

// $('body').on("click","#for-checkout",function() {
  // var  $this = $(this);
  // $(this).prop("disabled", true);
  // $this.find(".loader-check").css("display","block");
  // $.ajax({
  //   type: "post",
  //   url: base_url +"/checkout",
  //   data: $('#cart_data').serialize(),
  //   success: function(data) {
  //     if( $('#discounted_url').val() == '' ) {
  //       window.location.href = data.invoice_url;
  //     }else{
  //       window.location.href = $('#discounted_url').val();
  //     }
  //   },
  //   error:function(){
  //     $('.loader-overlay').css('display','none');
  //     $('.loader-check').css('display','none');
  //   },
  // });


  // window.location.href="/checkout";
  
// });



$('body').on("click","#apply_discount",function() {


  var currency=$(this).data('currency');



  $(this).prop("disabled", true);

  $('#loader').css('display','inline-block');

  $.ajax({
    type: 'post',
    url: base_url + "/apply-discount",
    data: $('#cart_data').serialize(),
    success: function(data) {
      //         if(data.invoice_url != 'you have enter an incorrect code' && data.invoice_url != 'please enter your discount code first'){
      if(data.error =='false'){ 
        $('#discount_code').val(data.coupon_code);
       
        $('#discounted_url').val(data.invoice_url);
        $('.message_box').empty();
        if(data.discount_type == 'percentage'){
          $('.message_box').append("*You have applied " +  data.discount_value + " % discount on cart ");
        }else{
          $('.message_box').append("*You have applied "+currency +  data.discount_value + " discount on cart ");
        }
        $('.message_box').css({'color':'green','padding':'3px'});
        $('.message_box').show();
      
        $('#cart-discount').html(currency+data.discount_amount);
        $('#for-cart-discount').css('display','block');
        var total = $('#cart-total').attr('data-value');
        total = (total / 100) - data.discount_amount;
        total = total.toFixed(2);
        $('#cart-total').html(currency+total);
        $('#loader').css('display','none');

      }else{

        $('.message_box').empty();

        $('.message_box').append('*'+data.invoice_url);



        $('.message_box').css('color','red');
        $('.message_box').show();
        $('#loader').css('display','none');
      }

    },error:function(){
      $('#loader').css('display','none'); 
    },
    complete: function(){
      $('#apply_discount').prop("disabled", false);
    }
  });
});

//   $('#has_discount').on('keyup keypress', function(e) {
//   var keyCode = e.keyCode || e.which;
//   if (keyCode === 13) { 
//     e.preventDefault();
//     return false;
//   }
// });

$(document).ready(function() {
  $(window).keydown(function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });
});


$(document).on('change', '.tetracustomvariant', function(){
  console.log('ggg')
  var this_is = $(this);
  var datagetid = $(this).find('option:selected').data('id');
  var qty = $(this).find('option:selected').data('qty');
  // $(this).parent().prev().find('.qty_text_val').text(qty);

  jQuery.getJSON('/cart.js', function(cart) {
    var item_var_id = 0 ;
    for (var i = 0; i < cart.items.length; i++) {
      var item_var_id = cart.items[i].id;
      if(item_var_id == datagetid){
        var var_qty_new = cart.items[i].quantity;
      }      
    }
    // console.log(var_qty_new);
    // console.log(var_qty_new);
    if(var_qty_new){
      $(this_is).parents('.pos_abs_grid').find('.css-s16q1a').find('.qty_text_val').text(var_qty_new);
    }else{
      $(this_is).parents('.pos_abs_grid').find('.css-s16q1a').find('.qty_text_val').text(qty);
    }
    // if($('body').hasClass('template-product')){
    //   // $(this).parents('.pos_abs_grid').find('a.grid-link').addClass('hhh');
    // $(this_is).parents('.pos_abs_grid').find('.css-s16q1a').find('.qty_text_val').text(var_qty_new);
    // }
    if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
      if(var_qty_new){
       $(this_is).parents('.pr-content').siblings('.pr-image-weapper').find('.css-s16q1a').find('.qty_text_val').text(var_qty_new);
      }else{
       $(this_is).parents('.pr-content').siblings('.pr-image-weapper').find('.css-s16q1a').find('.qty_text_val').text(qty);
      }
    }
  });
  
  
  $(this).parent().addClass('hiii')
  var ths_val = $(this).parent().prev().find('.multiplevariant');
  ths_val.parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-id',datagetid);
   $(this).parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-id',datagetid);
  var plus_nw_val__i = ths_val.parents('.pos_abs_grid').find('.css-14fuadz .qty_text_val').text();

  if($('body').hasClass('template-collection')){
    var variant_id = $(this).find('option:selected').attr('data-id');
    var variant_price = $(this).find('option:selected').attr('data-price');
    // $(this).parents('.pr-content').siblings('a.grid-link').find('p.grid-link__title').attr('data-variant-id',variant_id);
    // $(this).parents('.pr-content').find('p.price').html(variant_price);
    $(this).parents('.pos_abs_grid').find('p.grid-link__title').attr('data-variant-id',variant_id);
    $(this).parents('.pos_abs_grid').find('.pr-content').find('p.price').html(variant_price);
  }
});



$(document).on('click', '.css-5ra53n.multiplevariant', function(){
  // if(!$('body').hasClass('template-collection')){
  console.log('hh')

  var ths_val = $(this);
  if(ths_val.parents('.css-ya4lz1').find('.product-variant').is(":hidden")){

    $('.css-ya4lz1').find('.css-14w70yu').hide();
    $('.css-ya4lz1').find('.css-14fuadz').hide();
    $('.css-ya4lz1').find('.product-variant').hide();


    ths_val.parents('.css-ya4lz1').find('.css-14w70yu').show();
    ths_val.parents('.css-ya4lz1').find('.css-14fuadz').show();
    ths_val.parents('.css-ya4lz1').find('.product-variant').show();
    return false;
  }


  var $this = $(this);
  var limit_tags = JSON.parse($('body').attr('data-tags'));
  var tags = $this.parents('.css-s16q1a').attr('data-tags').split(','); 
  var weight = $this.parents('.css-s16q1a').find('.tetracustomvariant option:selected').attr('data-weight'); 
  if(weight == 0){
    weight = 100;
  }
  weight = parseFloat(weight);


  ths_val.parents('.css-ya4lz1').find('.css-14w70yu').show();
  ths_val.parents('.css-ya4lz1').find('.css-14fuadz').show();
  ths_val.parents('.css-ya4lz1').find('.product-variant').show();



  $.ajax({
    type: 'GET',
    url: '/cart?view=tags',
    success: function(cart){
      cart =  JSON.parse(cart);
      var qty = 1; // parseInt($this.parents('.css-s16q1a').find('.qty_text_val').text());
      console.log(cart, tags, limit_tags, weight, qty);


      var final_array = [];
      var has_enable = true;
      var total_weight = 0;

      $.each(limit_tags, function(i, limit_tag) {
        $.each(tags, function(i, current_tag) {
          if(current_tag == limit_tag.tag ){
            $.each(cart, function(i, cart_tag) {
              var in_array = $.inArray(current_tag, cart_tag.tags);
              if(in_array > -1){
                total_weight = total_weight + (cart_tag.grams * cart_tag.quantity);
              }
            });

            total_weight = total_weight + (weight * qty); 
            if(total_weight > limit_tag.grams){
              has_enable = false;
            }
          }
        });	
      });

      if(has_enable == true){

        var datagetid = $(this).find('option:selected').data('id');
        ths_val.parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-id',datagetid);
        var variant_item_qty = ths_val.parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-quantity');
        var plus_nw_val__i = ths_val.parents('.pos_abs_grid').find('.css-14fuadz .qty_text_val').text();
        var con_prd_qty_num_qty_1 = parseInt(plus_nw_val__i);

        if(con_prd_qty_num_qty_1 >= variant_item_qty){
          ths_val.removeClass('cursor_disabled');
        }
        else{
          con_prd_qty_num_qty_1 = parseInt(con_prd_qty_num_qty_1) + 1;
          ths_val.addClass('cursor_disabled');

        }


        var pro_qty = ths_val.parents('.css-ya4lz1').find('.css-14fuadz .qty_text_val').text();
        var pro_qty_total = parseInt(parseInt(pro_qty) + 1)
        ths_val.parents('.css-ya4lz1').find('.css-14fuadz .qty_text_val').text(pro_qty_total);
        var var_id = ths_val.parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-id');


        $this.parents('.css-s16q1a').find('.tetracustomvariant option:selected').attr('data-qty', pro_qty_total);
        $this.parents('.pos_abs_grid').find('.tetracustomvariant option:selected').attr('data-qty', pro_qty_total);
        
        var popup_attr = $this.parents('.pos_abs_grid').find('a').attr('data-src');
        if(popup_attr){
          $(popup_attr).find('.product-single .ajax_product_form .product-single__variants-select .swatch-wrapper a[data-var-id="'+var_id+'"]').attr('data-cart-qty',pro_qty_total);
        }
        if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
          var popup_attr = $this.parents('.pos_abs_grid').siblings('.pr-img').attr('data-src');
          if(popup_attr){
            $(popup_attr).find('.product-single .ajax_product_form .product-single__variants-select .swatch-wrapper a[data-var-id="'+var_id+'"]').attr('data-cart-qty',pro_qty_total);
          }
        }
        
        $('.css-14w70yu').removeAttr('disabled', 'disabled');

        var prd_id = ths_val.parents('.pos_abs_grid').find('.prd_title_grd').attr('product-id');
        function addItemToCart(variant_id, qty, properties) {
          var data = {
            "id": variant_id,
            "quantity": qty,
            "properties": {
              "product_id": properties
            }
          };

          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() {
              console.log('success');
              ths_val.parents('.css-ya4lz1').find('.css-14w70yu').show();
              ths_val.parents('.css-ya4lz1').find('.css-14fuadz').show();
              ths_val.parents('.css-ya4lz1').find('.css-5ra53n').addClass('new_val_add');
              ths_val.parents('.css-ya4lz1').find('.css-5ra53n').addClass('r_val_add');
              jQuery.getJSON('/cart.js', function(cart) {
                var item = cart.item_count;
                 if(item == 0){
                    $('.cart-page-link .cart-count').addClass('hidden-count');
                  }else{
                    $('.cart-page-link .cart-count').removeClass('hidden-count');
                  }
                $('.cart-page-link .cart-count').text(item);
              });
            },
            error: function() {
              ths_val.addClass('cursor_disabled');
            }
          });
        }
        addItemToCart(var_id, 1, prd_id)

      } else {
        $('.popup_weight').show();
      }
    }
  });
 // }
});
//   ********
function addItemToCart(variant_id, qty, properties) {
  var data = {
    "id": variant_id,
    "quantity": qty,
    "properties": {
      "product_id": properties
    }
  };

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      console.log('success');
      ths_val.parents('.css-ya4lz1').find('.css-14w70yu').show();
      ths_val.parents('.css-ya4lz1').find('.css-14fuadz').show();
      ths_val.parents('.css-ya4lz1').find('.css-5ra53n').addClass('new_val_add');
      ths_val.parents('.css-ya4lz1').find('.css-5ra53n').addClass('r_val_add');
      jQuery.getJSON('/cart.js', function(cart) {
        var item = cart.item_count;
        if(item == 0){
          $('.cart-page-link .cart-count').addClass('hidden-count');
        }else{
          $('.cart-page-link .cart-count').removeClass('hidden-count');
        }
        $('.cart-page-link .cart-count').text(item);
      });
    },
    error: function() {
      ths_val.addClass('cursor_disabled');
    }
  });
}
//     $(document).on('submit', '.ajax_product_form', function(e){
//       e.preventDefault();
//       var var_id = $('input').attr('name', 'id').val();
//       var var_qty = $('#Quantity').val();

//       console.log(var_id);
// //       addItemToCart(var_id, var_qty, prd_id)

//     });
$(document).on('click', '.css-5ra53n.singlevariant', function(e){
  // if(!$('body').hasClass('template-collection')){
  e.preventDefault();

  var ths_val = $(this);
  var $this = $(this);
  var limit_tags = JSON.parse($('body').attr('data-tags'));
  var tags = $this.parents('.css-s16q1a').attr('data-tags').split(','); 
  var weight = $this.parents('.css-s16q1a').attr('data-weight'); 
  if(weight == 0){
    weight = 100;
  }
  weight = parseFloat(weight);

  var variant_item_qty = $(this).parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-quantity');

  $('.css-ya4lz1').find('.css-14w70yu').hide();
  $('.css-ya4lz1').find('.css-14fuadz').hide();
  $('.css-ya4lz1').find('.product-variant').hide();

  ths_val.parents('.css-ya4lz1').find('.css-14w70yu').show();
  ths_val.parents('.css-ya4lz1').find('.css-14fuadz').show();
  ths_val.parents('.css-ya4lz1').find('.product-variant').show();


  $.ajax({
    type: 'GET',
    url: '/cart?view=tags',
    success: function(cart){
      cart =  JSON.parse(cart);
      var qty = 1; // parseInt($this.parents('.css-s16q1a').find('.qty_text_val').text());
      console.log(cart, tags, limit_tags, weight, qty);


      var final_array = [];
      var has_enable = true;
      var total_weight = 0;

      $.each(limit_tags, function(i, limit_tag) {
        $.each(tags, function(i, current_tag) {
          if(current_tag == limit_tag.tag ){
            $.each(cart, function(i, cart_tag) {
              var in_array = $.inArray(current_tag, cart_tag.tags);
              if(in_array > -1){
                total_weight = total_weight + (cart_tag.grams * cart_tag.quantity);
              }
            });

            total_weight = total_weight + (weight * qty); 
            if(total_weight > limit_tag.grams){
              has_enable = false;
            }
          }
        });	
      });

      if(has_enable == true){

        var plus_nw_val__i = $(this).parents('.css-ya4lz1').find('.css-14fuadz .qty_text_val').text();
        var con_prd_qty_num_qty_1 = parseInt(plus_nw_val__i);

        if(con_prd_qty_num_qty_1 >= variant_item_qty){
          ths_val.addClass('cursor_disabled');

        }
        else{
          con_prd_qty_num_qty_1 = parseInt(con_prd_qty_num_qty_1) + 1;
          ths_val.removeClass('cursor_disabled');

        }


        var pro_qty = ths_val.parents('.css-ya4lz1').find('.css-14fuadz .qty_text_val').text();
        var pro_qty_total = parseInt(parseInt(pro_qty) + 1)
        ths_val.parents('.css-ya4lz1').find('.css-14fuadz .qty_text_val').text(pro_qty_total);
        var var_id = $this.parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-id');
        $('.css-14w70yu').removeAttr('disabled', 'disabled');
        var prd_id = $this.parents('.pos_abs_grid').find('.prd_title_grd').attr('product-id');
        function addItemToCart(variant_id, qty, properties) {
          var data = {
            "id": variant_id,
            "quantity": qty,
            "properties": {
              "product_id": properties
            }
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() { 
              console.log('success');
              ths_val.parents('.css-ya4lz1').find('.css-14w70yu').show();
              ths_val.parents('.css-ya4lz1').find('.product-variant').show();
              ths_val.parents('.css-ya4lz1').find('.css-14fuadz').show();
              ths_val.parents('.css-ya4lz1').find('.css-5ra53n').addClass('new_val_add');
              ths_val.parents('.css-ya4lz1').find('.css-5ra53n').addClass('r_val_add');
              jQuery.getJSON('/cart.js', function(cart) {
                var item = cart.item_count;
                 if(item == 0){
                  $('.cart-page-link .cart-count').addClass('hidden-count');
                }else{
                  $('.cart-page-link .cart-count').removeClass('hidden-count');
                }
                $('.cart-page-link .cart-count').text(item);
              });
            },
            error: function() {
              ths_val.addClass('cursor_disabled');
            }
          });
        }
        addItemToCart(var_id, 1, prd_id);

      }else{
        $('.popup_weight').show();
      }
    }
  });



  // }
});



$(document).on("click",".css-14w70yu",function(event) {
  event.preventDefault();
  var ths = $(this);
  ths.parents('.css-ya4lz1').find('.css-14w70yu').show();
  ths.parents('.css-ya4lz1').find('.css-14fuadz').show();
  ths.parents('.css-ya4lz1').find('.product-variant').show();
  ths.removeAttr('disabled', 'disabled');
  ths.parent().find('.css-5ra53n').removeClass('cursor_disabled');


  // var prd_id = $(this).parents('.pos_abs_grid').find('.prd_title_grd').attr('product-id');
  var prd_id = $(this).parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-id');
  var minus_nw_val__i = $(this).parents('.css-ya4lz1').find('.css-14fuadz .qty_text_val').text();
  if(parseInt(minus_nw_val__i)==0){
    return false;
  }
  var con_prd_qty_minus_qty_1 = parseInt(minus_nw_val__i) - 1;
  ths.parents('.css-ya4lz1').find('.css-14fuadz .qty_text_val').text(con_prd_qty_minus_qty_1);

  if($(this).parents('.css-s16q1a').find('.tetracustomvariant')){
    $(this).parents('.css-s16q1a').find('.tetracustomvariant option:selected').attr('data-qty', con_prd_qty_minus_qty_1);
  }
  $(this).parents('.pos_abs_grid').find('.tetracustomvariant option:selected').attr('data-qty', con_prd_qty_minus_qty_1);
  var popup_attr = $(this).parents('.pos_abs_grid').find('a').attr('data-src');
  var varid =   ths.parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-id');
  if(popup_attr){
    $(popup_attr).find('.product-single .ajax_product_form .product-single__variants-select .swatch-wrapper a[data-var-id="'+varid+'"]').attr('data-cart-qty',con_prd_qty_minus_qty_1);
  }


  var var_qty_new = 0;
  var delArray = [];
  if(con_prd_qty_minus_qty_1 <= 0){
    ths.attr('disabled', 'disabled');
  }

  jQuery.getJSON('/cart.js', function(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      // var item_var_id = cart.items[i].properties.product_id;
      var item_var_id = cart.items[i].id;
      if(item_var_id == prd_id){
        var item_var_id = cart.items[i].id;
        var var_qty_new = cart.items[i].quantity;
        delArray.push(item_var_id);
      }
      else{

      }
    }

    if(con_prd_qty_minus_qty_1 >= 0){
      var qty = 0;
    }
    // $(rawItems).each(function() {
    var varid =   ths.parents('.pos_abs_grid').find('.prd_title_grd').attr('data-variant-id');
    var prd_qty_num = var_qty_new - 1;


    console.log(varid)
    console.log(delArray)
    if(varid == delArray){
      qty = prd_qty_num;
    }


    for (var i=delArray.length; i--;) {
      delArray[i] = 'updates[' + delArray[i]+ ']='+qty;
    }

    var updates = delArray.join('&'); 	

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: updates,
      dataType: 'json',
      success : function(){

        if(con_prd_qty_minus_qty_1 >= 0){
          console.log('no_intrrupt');
        }
        else{
        }
        jQuery.getJSON('/cart.js', function(cart) {
          var item = cart.item_count;
           if(item == 0){
            $('.cart-page-link .cart-count').addClass('hidden-count');
          }else{
            $('.cart-page-link .cart-count').removeClass('hidden-count');
          }
          $('.cart-page-link .cart-count').text(item);

        });     
      },
      fail : function(){
      }
    });
    //}, 100);
  });
});  

$('body').click(function(evt){    
  if(evt.target.class == "product-variant")
    return;
  if($(evt.target).closest('.product-variant').length || $(evt.target).closest('.css-5ra53n').length)
    return;             
  $('.css-14w70yu').hide();
  $('.css-14fuadz').hide();
  // $('.product-variant').hide();
  if(!$('body').hasClass('template-product')){
    $('.product-variant').hide();
  }
});


$(document).on('click', '.minus_bb', function(){
  var $input = $(this).parent().find('input');
  var count = parseInt($input.val()) - 1;
  //  by HASSAN FAROOQ = cart quantity update in cart-count   
  //     $('.cart-page-link .cart-count').text(count);
  //     var status = CalculateWeight($input, count);
  //     console.log(status);

  //     if(status == true){
  count = count < 1 ? 0 : count;
  $input.val(count);
  //     }else{
  //       alert('You cant decrease more weight');
  //     }
});

$(document).on('click', '.plus_bb', function(){
  var $input = $(this).parent().find('input');
  var count = parseInt($input.val()) + 1;
  //  by HASSAN FAROOQ = cart quantity update in cart-count             
  //     $('.cart-page-link .cart-count').text(count);
  var status = CalculateWeight($input, count);
  console.log(status);
  if(status == true){
    $input.val(count);
  }else{
    $('.popup_weight').show();
  }

});



function CalculateWeight(input, qty){
  var tags = $('body').attr('data-tags');
  var tags =  JSON.parse(tags);
  var current_tags = input.attr('data-tags');
  var grams = parseFloat(input.attr('data-weight'));
  if(grams == 0){
    grams = 100;
  }
  current_tags = current_tags.split(',')
  console.log(tags, current_tags, grams, qty);
  var enable = true;
  $.each(current_tags, function(i, current_tag) {
    $.each(tags, function(i, tag) {
      if(tag.tag == current_tag){
        var current_weight = grams * qty;
        var limit_weight = parseFloat(tag.grams);
        if(current_weight > limit_weight){
          enable = false;
        }
      }
    });
  });
  console.log(enable);
  return enable;
}



$('body').on('submit', '.cart', function(event) {
  $.ajax({
    type: 'POST',
    url: $(this).attr('action'),
    data: $(this).serialize(),
    dataType: 'json',
    success: function(cart) {
      getcarthtml();
    },
    error: function() {
      // Show an error message.
    },
    complete: function() {
      $(this).append('<p>AJAX response received.</p>');
    }
  });
  event.preventDefault();
});

function getcarthtml(){
  $.ajax({
    url:'/cart',
    type:'GET',
    success: function(data){
      $("div#CartSection").html('');
      $("div#CartSection").html($(data).find('#CartSection').html());
      var qty = 0;
      $('.cart__quantity-selector').each(function(){
        qty = qty + parseInt($(this).val());        
      });
       if(qty == 0){
          $('.cart-page-link .cart-count').addClass('hidden-count');
        }else{
          $('.cart-page-link .cart-count').removeClass('hidden-count');
        }
      $('.cart-page-link .cart-count').text(qty);
    },
  });
}

$(document).on('change', '#ProductSelect-collection-template', function(){
  $(this).parent('form').prev('.product-single__prices').find("#ProductPrice").text($(this).find(':selected').data('price'));
});


  
$('body').on('click','.popup_content .close_icon', function(){
  $('.popup_weight').hide();
});

$('body').on('submit', '.ajax_product_form', function(e){
  e.preventDefault();
  var $this = $(this);
  var limit_tags = JSON.parse($('body').attr('data-tags'));
  var cart = JSON.parse($this.attr('data-cart'));
  var tags = $this.attr('data-tags').split(',');
  var variant = $this.find('.product-single__variants').val();
  var weight = 100;
  var qty = parseInt($this.find('.quantity-selector').val());

  $this.find(".as_fload_cart span").css('visibility','hidden');
  $this.find(".loader-check").css("display","block");
  //     $this.find(".as_fload_cart").addClass("btn--loading");
  //     $this.find(".as_fload_cart").addClass("loader-check");

  $this.find('.product-single__variants option').each(function(){
    if($(this).attr('value') == variant){
      weight = $(this).attr('data-weight');
      if(weight){
        weight = parseFloat(weight);
      }
    }
  });
  var final_array = [];
  var has_enable = true;
  var total_weight = 0;

  $.each(limit_tags, function(i, limit_tag) {
    $.each(tags, function(i, current_tag) {
      if(current_tag == limit_tag.tag ){
        $.each(cart, function(i, cart_tag) {
          var in_array = $.inArray(current_tag, cart_tag.tags);
          if(in_array > -1){
            total_weight = total_weight + (cart_tag.grams * cart_tag.quantity);
          }
        });

        total_weight = total_weight + (weight * qty); 
        if(total_weight > limit_tag.grams){
          has_enable = false;
        }
      }
    });	
  });

  if(has_enable == true){
    //       $('#AddToCart').addClass("btn--loading");
    AddToCart($this);
  }else{
    $('.popup_weight').show();
  }
});

$('.clear-cart-btn-ajax').on('click',function(e){ 
  e.preventDefault(); 
  var $this = $(this);

  $this.addClass('loading');
  $.ajax({ 
    type: "POST", 
    url: '/cart/clear.js', 
    data: $this.serialize(),
    success: function(){ 
      console.log('I cleared the cart!'); 
      setCookie('session', "Cart Cleared Successfully", 1);
      setCookie('session_type', "success", 1);
      window.location.href = '/cart';
    }, 
    dataType: 'json'
  });
});

$(document).on("submit", ".update_address", function(e) {
  e.preventDefault();
  var $this = $(this);

  $this.addClass('loading');
  $.ajax({
    type: $this.attr('method'),
    url: $this.attr('action'),
    data: $this.serialize(),
    success: function(data) {
      setCookie('session', "Address has been updated.", 1);
      setCookie('session_type', "success", 1);
      window.location.href = '/account/addresses';
    }
  });
});

$(document).on("click", ".asBackFromCart", function(e) {
  history.back(); 
  location.reload();
  window.location.href = '/account/addresses';
});
$(document).on("submit", ".addnew_address", function(e) {
  e.preventDefault();
  var $this = $(this);

  $this.addClass('loading');
  $.ajax({
    type: $this.attr('method'),
    url: $this.attr('action'),
    data: $this.serialize(),
    success: function(data) {
      setCookie('session', "New address has been added successfully.", 1);
      setCookie('session_type', "success", 1);
      window.location.href = '/account/addresses';
    }
  });
});

$(document).on("submit", ".change--pass", function(e) {
  e.preventDefault();
  var $this = $(this);

  $this.addClass('loading');
  $.ajax({
    type: $this.attr('method'),
    url: $this.attr('action'),
    data: $this.serialize(),
    success: function(data) {
      setCookie('session', "Email has been send successfully.", 1);
      setCookie('session_type', "success", 1);
      window.location.href = '/account?view=details';
    },
    error: function(data, error){
      setCookie('session', "Something went wrong, pleas try agin later.", 1);
      setCookie('session_type', "error", 1);
      window.location.href = '/account?view=details';
    }
  });
});

$(document).on("submit", "#name--form", function(e) {
  e.preventDefault();
  var $this = $(this);

  $this.addClass('loading');
  $.ajax({
    type: $this.attr('method'),
    url: $this.attr('action'),
    data: $this.serialize(),
    success: function(data) {
      setCookie('session', "Name has been updated.", 1);
      setCookie('session_type', "success", 1);
      window.location.href = '/account?view=details';
    }
  });
});

//   rating app submissions script start
//   $('.rating-submit').click(function(e) {
//     e.preventDefault();
//     var base_url = 'https://phpstack-711164-2355937.cloudwaysapps.com';
//     //     var data = $(".order-rating-form").serialize();

//     var form = $('.order-rating-form')[0];
//     var formData = new FormData(form);
//     $(".rating-submit").find(".loader-check").css("display","block");
//     $(".rating-submit").find("span").css("visibility","hidden");
//     $.ajax({
//       url: base_url + "/order-rating",
//       headers: {
//         'Sec-Fetch-Site':'same-origin',
//       },
//       type: 'POST',
//       data: formData,
//       processData: false,
//       contentType: false,
//       success: function(data) {
//         if(data){
//           setCookie('session', "Thanks for rating the order.", 1);
//           setCookie('session_type', "success", 1);
//           $(".rating-submit").find(".loader-check").css("display","none");
//           $(".rating-submit").find("span").css("visibility","visible");
//           $(document).find('.closeRattingPopup').click();
//           location.reload();
//         }
//       },
//       error: function(jqXHR, textStatus, errorThrown){
//         setCookie('session', "Issue in submitting your rating Try Again Later.", 1);
//         setCookie('session_type', "error", 1);
//         $(".rating-submit").find(".loader-check").css("display","none");
//         $(".rating-submit").find("span").css("visibility","visible");
//         $(document).find('.closeRattingPopup').click();
//         location.reload();
//       }
//     });
//   });

//   order page rating
$("body").on('submit','.order-rating-form',function(e) {
  e.preventDefault();
  var base_url = 'https://phpstack-711164-2355937.cloudwaysapps.com';
  var form = this;
  var formData = new FormData(this); 
  $(".rating-submit-to").find(".loader-check").css("display","block");
  $(".rating-submit-to").find("span").css("visibility","hidden");
  $.ajax({
    url: base_url + "/order-rating",
    headers: {
      'Sec-Fetch-Site':'same-origin',
    },
    type: 'POST',
    data: formData,
    processData: false,
    contentType: false,
    success: function(data) {
      if(data){
        setCookie('session', "Thanks for rating the order.", 1);
        setCookie('session_type', "success", 1);
        $.fancybox.close();
        $(".rating-submit-to").find(".loader-check").css("display","none");
        $(".rating-submit-to").find("span").css("visibility","visible");
        location.reload();
      }
    },
    error: function(jqXHR, textStatus, errorThrown){
      setCookie('session', "Issue in submitting your rating Try Again Later.", 1);
      setCookie('session_type', "error", 1);
      $(document).find('.is-close').click();
      $(".rating-submit-to").find(".loader-check").css("display","none");
      $(".rating-submit-to").find("span").css("visibility","visible");
      $(document).find('.closeRattingPopup').click();
      location.reload();
    }
  });
});


//   rating app submissions script end

$(".phone--mask").inputmask({"mask": "+1 999 999 9999"});
//$(":input").inputmask();

$(document).on("submit", "#phone--form", function(e) {
  e.preventDefault();
  var $this = $(this);

  $this.addClass('loading');
  $.ajax({
    type: $this.attr('method'),
    url: $this.attr('action'),
    data: $this.serialize(),
    success: function(data) {
      setCookie('session', "Phone Number has been updated.", 1);
      setCookie('session_type', "success", 1);
      window.location.href = '/account?view=details';
    },
    error: function(data){
      console.log(data);
    }
  });
});




$('.as-banner .closeHomeBanner').click(function(){
  setCookie('order_banner', "hide", 1);
  $(this).parents('.as-banner').hide();
});

$('.collectBannerContent .closeBanner').click(function(){
  setCookie('collection_banner', "hide", 0);
  $(this).parents('.collectBannerContent').hide();
});

// Modified contents of customer_area.js (global asset)
Shopify.CustomerAddress = {
  destroy: function(url, confirm_msg) {
    if (confirm(confirm_msg || "Are you sure you want to delete this address?")) {
        Shopify.postLink(url, {'parameters': {'_method': 'delete'}});
    setCookie('session', "Your Address has been Deleted successfully.", 1);
    setCookie('session_type', "success", 1);
  }
}
}


                //                   $('.as-banner').css("display", "none");

                // $('.closeHomeBanner').click(function(){
                //     $('.as-banner').css("display", "none");
                // }).setCookie('session', "success", 1);


                function checkSession(){
var session_text = getCookie('session');
var session_type  =  getCookie('session_type');
toastr.options = {
  "closeButton": false,
  "debug": false,
  "newestOnTop": true,
  "progressBar": false,
  "positionClass": "toast-top-center",
  "preventDuplicates": false,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
}

if(session_text){
  if(session_type == 'success'){
    toastr.success(session_text);
  }

  if(session_type == 'error'){
    toastr.error(session_text);
  }

  setCookie('session', "A", -1);
  setCookie('session_type', "A", -1);
}
}


function setCookie(cname, cvalue, exdays) {
const d = new Date();
d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
let expires = "expires="+d.toUTCString();
document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
let name = cname + "=";
let ca = document.cookie.split(';');
for(let i = 0; i < ca.length; i++) {
  let c = ca[i];
  while (c.charAt(0) == ' ') {
    c = c.substring(1);
  }
  if (c.indexOf(name) == 0) {
    return c.substring(name.length, c.length);
  }
}
return "";
}


function AddToCart(form){
jQuery.ajax({
  type: form.attr('method'),
  url: form.attr('action'),
  data: form.serialize(),
  success: function(data) {

    console.log('success');
    jQuery.getJSON('/cart.js', function(cart) {
      var item = cart.item_count;
        if(item == 0){
          $('.cart-page-link .cart-count').addClass('hidden-count');
        }else{
          $('.cart-page-link .cart-count').removeClass('hidden-count');
        }
      $('.cart-page-link .cart-count').text(item);
      $.fancybox.close();
      $(".as_fload_cart span").css('visibility','visible');
      $(".loader-check").css("display","none");
    });
    //       window.location.href = "/cart";	
  }
});
}


// swiper product slider
// var slider = new Swiper ('.gallery-slider', {
//     slidesPerView: 1,
//     centeredSlides: true,
//     loop: true,
//     loopedSlides: 6,
// });

// var thumbs = new Swiper ('.gallery-thumbs', {
//     slidesPerView: 'auto',
//     spaceBetween: 10,
//     centeredSlides: true,
//     slideToClickedSlide: true,
// });

// slider.controller.control = thumbs;
// thumbs.controller.control = slider;

});

$(document).ready(function(){
/// Main search input

//   $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
//     $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
//   });


/// Live search

// var searchTimeoutThrottle = 100;
var searchTimeoutThrottle = 1000;
var searchTimeoutID = -1;
var currReqObj = null;
var $resultsBox = $('<div class="results-box" ></div>').appendTo('#pageheader .search-box');
var $r_results = $('.results-box');

$('#pageheader .search-box input[type="text"]').on('keydown', function(event) {
  if (event.keyCode === 13) {
      event.preventDefault();
        // var length = $(this).parents('.non_collection_page').length;
        // console.log(length)
      if($(this).parents('.non_collection_page').length > 0){
        var $form = $(this).closest('form');
        var term = '' + $form.find('input[name=""]').val() + '';
        var linkURL = $form.attr('action') + '?type=product&q=' + term;
        console.log(linkURL)
        window.location = linkURL;
        // $('#pageheader .search-form').submit();
      }else{
        $('.collection_page .search-form').trigger('submit');
      }
   
  }
});
$('#pageheader .search-box input[type="text"]').bind('keyup', function(){
  $r_results.addClass('search_loading');
  if($(this).val()) {
    clearTimeout(searchTimeoutID);

    var $form = $(this).closest('form');
    var term = '' + $form.find('input[name=""]').val() + '';
    var linkURL = $form.attr('action') + '?type=product&q=' + term;
    var vendor = $form.attr('data-vendor');
    console.log(linkURL);
    console.log(term);
    
    searchTimeoutID = setTimeout(function(){
      console.log(term)
      currReqObj = $.ajax({
        url: $form.attr('action'),
        data: {
          view: 'products',
          type: 'product',
          q: "title:"+term+"\*",
        },
        dataType: "html",
        success: function(data){    
          $form.next().html(data);
          if(vendor){
            var counter = 0;
            $form.next().find('a').each(function(){
              if($(this).attr('data-vendor') == vendor){
                $(this).show();
                counter = counter + 1;
              }
            });
            if(counter == 0){
              $form.next().html('<div class="">No Product Found.</div>');
              console.log("no product");
              $(this).attr('disabled', true);
            }
          }else{
            $form.next().find('a').show();
          }
          $(this).attr('disabled', false);
          $r_results.removeClass('search_loading');
        }
      });
    }, searchTimeoutThrottle);
  } else if ($(this).val().length <= 2) {
    //Deleted text? Clear results
    $resultsBox.empty();
  }
}).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
  //Focus, show results

  $resultsBox.fadeIn(200);
}).bind('click', function(e){
  e.stopPropagation();
});

$('.non_collection_page .search-form, .non_collection_page #search-form').on('submit', function(e){
  e.preventDefault();
  var term = '' + $(this).find('input[name=""]').val() + '';
  var linkURL = $(this).attr('action') + '?type=product&q=' + term +"*";
  window.location = linkURL;
});


$('.collection_page .search-form, .collection_page #search-form').on('submit', function(e){
  e.preventDefault();
  var term = '' + $(this).find('input[name=""]').val() + '';
  var linkURL = $(this).attr('action') + '?type=product&view=store&q=' + term+"*";
  var vendor_name = $(this).attr('data-vendor');
  $('.all_products').addClass('loading');
  $('.results-box').empty();
  $('.productAjax').removeClass('selected');
  $('.top--search-bar').removeClass('top--open');
  $.ajax({
    type: 'GET',
    url: linkURL,
    success: function(data) {
      $('.template-collection .col-srch-rslt-txt').text('Results for "'+term+'"');
      $('.collectionChangesTemp').find("#more_div").empty();
      //$('.all_products').html(data);
      $('#colDesktopTags').hide();
      $('#AjaxinateContainer').html(data);
      $('#AjaxinatePagination').html('');
      var counter = 0;
      $('.all_products').find('.all_single_product').each(function(){
        if($(this).attr('data-vendor') == vendor_name){
          $(this).show();
          counter = counter + 1;
        }
      });

      if(counter == 0){
        $('.all_products').html('<div class="grid__item all_single_product">No Product Found.</div>');
      }

      $('.all_products').removeClass('loading');
      $('.results-box').empty();
      document.activeElement.blur();
      $("html, body").animate({ 
        scrollTop: 0
      }, "fast");
    }
  });

});

});

// get order no for report issue page
$(document).ready(function(){
var order_no="";
var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');  
for (var i = 0; i < url.length; i++) {  
  var urlparam = url[i].split('=');  

  if (urlparam[0] == 'order') {  
    order_no= urlparam[1];  
  }  
}  
console.log(order_no);
$('#reportOrderNumber').html(order_no);

//   $(".product-variant select.select-variant").on('change', function(){

$("body").on('change',".product-variant select.select-variant", function(){
  let dataprice = $(this).find(':selected').data('price');
  let datadiscount = $(this).find(':selected').data('discount');
  let datatitle = $(this).find(':selected').data('weight');
  //     datatitle = datatitle.split('/')[0];
  var datatitleInt = datatitle;
  datatitleInt=parseInt(datatitleInt);
  var datatitleChar = "g";
  //         alert("Char : " + datatitleChar + "\n" + "Int : " + datatitleInt);
  if(datatitleInt == 1000){
    datatitleInt = datatitleInt/1000;
    datatitleChar = "kg";
    datatitle = datatitleInt + datatitleChar;
  }
  else if(datatitleInt > 1000){
    datatitleInt = parseFloat(datatitleInt / 1000).toFixed(1);
    datatitleChar = "kg";
    datatitle = datatitleInt + datatitleChar;
  }
  else{
    datatitle = datatitleInt + datatitleChar;
  }

  // this is not appropriate way of finding nodes
  $( this ).parent().parent().parent().parent().parent().parent().parent().parent().find(".grid-link__meta .as_discont").html(datadiscount);
  $( this ).parent().parent().parent().parent().parent().parent().parent().parent().find(".grid-link__meta .price").text(dataprice);
  $( this ).parent().parent().parent().parent().parent().parent().parent().parent().find(".grid-link__meta .quantity").text(datatitle);
});


$("body").on('change', ".product-single__variants", function(){
  let dataprice = $(this).find(':selected').data('price');
  let compare_at_price = $(this).find(':selected').data('compare-price');
  //alert(dataprice);
  if($('body').hasClass('template-collection')){
    $(this).parents('form').siblings('.product-single__prices span').find(".product-single__price").html(dataprice);
    $(this).parents('.fancybox-content').find(".product-single.as-quick_view_changes .product-single__price span").html(dataprice);
  }
  $(this).parents('.fancybox-content').find(".product-single.as-quick_view_changes .product-single__price span").html(dataprice);
  $(this).parents('form').siblings('.product-single__prices').find(".product-single__price span").html(dataprice);
  $(this).parents('#ProductSection').find(".product-single.pdp_template .product-single__price span").html(dataprice);
  
  $(this).parent().parent().parent().find(".product-single__price").html(dataprice);
  if(compare_at_price){
    // $(this).parents('form').siblings('.product-single__prices').find(".product-single__sale-price").html(dataprice);
    $(this).parent().parent().parent().find(".product-single__sale-price").html(compare_at_price);
  }else {
    // $(this).parents('form').siblings('.product-single__prices').find(".product-single__sale-price").html('');
    $(this).parent().parent().parent().find(".product-single__sale-price").html('');
  }
  //     $(".product-single__price").text(dataprice);
});


//   $("body").on('change', ".product-single__variants", function(){
//     let dataprice = $(this).find(':selected').data('price');
//     //alert(dataprice);
//     $(this).parent().parent().parent().find(".product-single__price").text(dataprice);
//     //     $(".product-single__price").text(dataprice);
//   });



$("#pageheader").delegate(".results-box a", "click", function(){

  let link_hr = $(this).data('href');
  //alert(link_hr);
});

});

// $(document).ready(function() {
//         var datatitle1 = $(".grid-link__meta .quantity").text();
//         console.log(datatitle1);                   
//         var datatitleInt = datatitle1;
//         datatitleInt=parseInt(datatitleInt);
//         var datatitleChar = "g";
//         if(datatitle1>=1000){
//           datatitleInt = parseFloat(datatitleInt / 1000).toFixed(1);
// //           datatitleInt = parseFloat(datatitleInt / 10).toFixed(1);
//       	  datatitleChar = "kg";
//           datatitle1 = datatitleInt + datatitleChar;
//         }
//         else{
//           datatitle1 = datatitleInt + datatitleChar;
//         }
//         $(".grid-link__meta").find('asQuantity').text(datatitle1);
// });

// $( document ).ready(function() {
//   var base_url = 'https://phpstack-711164-2355937.cloudwaysapps.com';
//   var id = $('#order_id').val();
//   $.ajax({
//     url: base_url + "/get-status/"+id+"?status=customer",
//     type: 'GET',
//     success: function(data) {
//       if(data.label != 'not pushed on dhl yet !'){
//         $('#gallery_col_ttle span').html(data.label);
//         $('#gallery_col_subttle span').html(data.time);
//       }else{
//         console.log(data.label);
//       }
//     }
//   });
// });

// $(document).ready(function() {
//   var numb = $(".as_rating_number").data('rating');
//   console.log("Total stars: " + numb);
//   $('.show_review').find('ul li').each(function() {
//     if($(this).data('value')<=numb){
//       $(this).html('&#9733;');
//     }
//   });
// });
/*
$(document).on("submit", "#create_customer", function(e){
  e.preventDefault();
  var base_url = 'https://phpstack-711164-2355937.cloudwaysapps.com';
  $.ajax({
    url: base_url+"/createcustomer",
    data:$("#create_customer").serialize(),
    type: 'POST',
    success: function(data) {
      console.log(data);
    }
  });
});

var base_url = 'http://phpstack-711164-2441519.cloudwaysapps.com/createcustomer/';
var id = $('#order_id').val();
$.ajax({
  url: base_url + "?status=customer",
  type: 'GET',
  success: function(data) {
    if(data.label != 'not pushed on dhl yet !'){
    $('#gallery_col_ttle').html(data.label);
    $('#gallery_col_subttle').html(data.time);
    }else{
      console.log(data.label);
    }
  }
});
*/


$(document).ready(function() {

var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 200);
}
ALAcheck();
function customALA() {
var selector = $('.product-recommendations .grid-uniform');
  if(selector.length > 0) {
    console.log('loaded')
    clearInterval(isALARendered);        
      $(document).on('click','.swatch-wrapper a.swatch', function(e){
        console.log('clicked');
        let text = e.target.tagName;
        console.log(text)
        if(text == 'SPAN'){     
          // $(e.target).parent('a').addClass('hhh');
          $(this).siblings('a.swatch').removeClass('active');
          $(this).addClass('active');
        }else{
          $(this).siblings('a.swatch').removeClass('active');
          $(this).addClass('active');
        }
        if($(this).hasClass('swatch-color')){
           $(this).siblings('a.swatch').find('span').removeClass('active');
           $(this).find('span:first').addClass('active');
        }
        var value = $(this).attr('data-change-value');
        var length = $(this).parents('.variant_Dropdown_wrapper').find('.swatch-wrapper').length;
        console.log('val',value);
        console.log(length);
        // var index_for = length - 1;
        var final_value = '';
        var last_value = false;
        for(var i=0;i<=length-1;i++){
          var val = $(this).parents('.variant_Dropdown_wrapper').find('.swatch-wrapper').eq(i).find('a.swatch.active').attr('data-change-value');
          if(final_value){
            final_value = final_value + ' / ' + val;
          }else{
            final_value =  val;
          }
          console.log(i)
          if(i==length-1){
            var last_value = true;
          }
        }
        if(last_value){
         var var_id = $(this).parents('.variant_Dropdown_wrapper').find('select[name="id"] option[data-var-title="'+final_value+'"]').attr('value');
        console.log(var_id);
           var var_available = $(this).parents('.variant_Dropdown_wrapper').find('select[name="id"] option[data-var-title="'+final_value+'"]').attr('disabled');
          
          if(var_available == 'disabled'){
            $(this).parents('.product-single__variants-select').siblings('.sticky-add-to-cart').find('button.as_fload_cart').attr('disabled','disabled');
            $(this).parents('.product-single__variants-select').siblings('.sticky-add-to-cart').find('button.as_fload_cart #AddToCartText').text('Sold Out');
            $(this).parents('.product-single__variants-select').siblings('.sticky-add-to-cart').find('button.as_fload_cart svg').hide();
          }else{
            $(this).parents('.product-single__variants-select').siblings('.sticky-add-to-cart').find('button.as_fload_cart').removeAttr('disabled');
            var btn_text = $(this).parents('.product-single__variants-select').siblings('.sticky-add-to-cart').find('button.as_fload_cart #AddToCartText').attr('data-ori-text');
            $(this).parents('.product-single__variants-select').siblings('.sticky-add-to-cart').find('button.as_fload_cart #AddToCartText').text(btn_text);
            $(this).parents('.product-single__variants-select').siblings('.sticky-add-to-cart').find('button.as_fload_cart svg').show();
            $('.variant_Dropdown_wrapper select[name="id"]').val(var_id).trigger('change');
    
            var cart_qty = parseInt($(this).attr('data-cart-qty'));
            $(this).parents('.product-single__variants-select').siblings('.product-single__quantity').find('.quantity-selector').addClass('hii');

            if(cart_qty > 0){
              $(this).parents('.product-single__variants-select').siblings('.product-single__quantity').find('.quantity-selector').val(cart_qty);
            } else {
              $(this).parents('.product-single__variants-select').siblings('.product-single__quantity').find('.quantity-selector').val(1);
            }
            if(cart_qty > 0){
               $(this).parents('.product-single__variants-select').siblings('.sticky-add-to-cart').find('button.as_fload_cart #AddToCartText').text('UPDATE CART');
            }
          }
          
          $(this).parents('.variant_Dropdown_wrapper').find('select[name="id"]').val(var_id).trigger('change');
        }
        // var var_id = $(this).attr('data-var-id');
        // $('.variant_Dropdown_wrapper select[name="id"]').val(var_id).trigger('change');
        
        // var text_value = $('.variant_Dropdown_wrapper select[name="id"] option:selected').text();
        // console.log(text_value)
    
        // $(this).parents('.swatch-wrapper').siblings('.swatch-wrapper').find('a').each(function(){
        //   var a_value = $(this).attr('data-change-value');
        //   console.log(text_value);
        //   if(text_value.includes(a_value)){
        //     if($(this).hasClass('swatch-color')){
        //       $(this).siblings('a.swatch').find('span').removeClass('active');
        //       $(this).find('span:first').addClass('active');
        //       $(this).addClass('active');
        //     }else{
        //       $(this).siblings('a.swatch').removeClass('active');
        //       $(this).addClass('active');
        //     }
            
        //   }
        // });
      });
  }  
}
  


  // $('.clear-cart-btn-ajax').on('click',function(e){ 
  //   e.preventDefault(); 
  //   console.log('clear-btn-click-next');
  //   $.ajax({ 
  //     console.log('clear-btn-click-next-ajax');
  //     type: "POST", 
  //     url: '/cart/clear.js', 
  //     success: function(){ 
  //       alert('I cleared the cart!'); 
  //     }, 
  //     dataType: 'json'
  //   });
  // });
  $(document).on('click','a[data-fancybox]',function(){
    console.log('clicked');
    var popup_attr = $(this).attr('data-src');
     
   
    if(popup_attr){
       $(popup_attr).animate({
      scrollTop: $(popup_attr).offset().top
      }, 500);
      $(popup_attr).find('.product-single .ajax_product_form .product-single__variants-select .swatch-wrapper a.active').trigger('click');
    }
  });
  $(document).on('click','.pr-img[data-fancybox]',function(){
    console.log('clicked');
    var popup_attr = $(this).attr('data-src');
    if(popup_attr){
      $(popup_attr).find('.product-single .ajax_product_form .product-single__variants-select .swatch-wrapper a.active').trigger('click');
    }
  });
  $('body').on('click', '.ajax_product_form button#AddToCart', function(e){
    console.log('hiiii');
      e.preventDefault();
  var $this = $(this);
  var form = $(this).parents('.ajax_product_form');
  var limit_tags = JSON.parse($('body').attr('data-tags'));
  var cart = JSON.parse(form.attr('data-cart'));
  var tags = form.attr('data-tags').split(',');
  var variant = form.find('.product-single__variants').val();
  // var variant = form.find('[name="id"]').val();
  //   if(!variant){
  //     var variant = form.find('#ProductSelect-product-recommendations').val();
  //     console.log(variant)
  //   }
    
  var pro_id = form.attr('data-pro-id');
  var weight = 100;
  var qty = parseInt(form.find('.quantity-selector').val());
    
        form.find(".as_fload_cart span").css('visibility','hidden');
        form.find(".loader-check").css("display","block");
        //     $this.find(".as_fload_cart").addClass("btn--loading");
        //     $this.find(".as_fload_cart").addClass("loader-check");
      
        form.find('.product-single__variants option').each(function(){
          if($(this).attr('value') == variant){
            weight = $(this).attr('data-weight');
            if(weight){
              weight = parseFloat(weight);
            }
          }
        });
        var final_array = [];
        var has_enable = true;
        var total_weight = 0;
      
        $.each(limit_tags, function(i, limit_tag) {
          $.each(tags, function(i, current_tag) {
            if(current_tag == limit_tag.tag ){
              $.each(cart, function(i, cart_tag) {
                var in_array = $.inArray(current_tag, cart_tag.tags);
                if(in_array > -1){
                  total_weight = total_weight + (cart_tag.grams * cart_tag.quantity);
                }
              });
      
              total_weight = total_weight + (weight * qty); 
              if(total_weight > limit_tag.grams){
                has_enable = false;
              }
            }
          });	
        });
      
        if(has_enable == true){
          if(qty == 0){
            form.find(".as_fload_cart span").css('visibility','visible');
            form.find(".loader-check").css("display","none");
          }
          //       $('#AddToCart').addClass("btn--loading");
          // AddToCart($this);
          console.log('ready for cary');
        
          jQuery.getJSON('/cart.js', function(cart) {
            var item_in = false;
            for (var i = 0; i < cart.items.length; i++) {
              // var item_var_id = cart.items[i].properties.product_id;
              var item_var_id = cart.items[i].id;
              if(item_var_id == variant){
                item_in = true;
                var item_var_id = cart.items[i].id;
                // var var_qty_new = cart.items[i].quantity;
                // delArray.push(item_var_id);
              }
            }
            if(item_in){
                var delArray = [];
                delArray.push(variant);
                  // $(rawItems).each(function() {
                  for (var i=delArray.length; i--;) {
                    delArray[i] = 'updates[' + delArray[i]+ ']='+qty;
                  }
              
                  var updates = delArray.join('&'); 	
              
                  $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: updates,
                    dataType: 'json',
                    success : function(){
              
                      jQuery.getJSON('/cart.js', function(cart) {
                        var item = cart.item_count;
                         if(item == 0){
                          $('.cart-page-link .cart-count').addClass('hidden-count');
                        }else{
                          $('.cart-page-link .cart-count').removeClass('hidden-count');
                        }
                        $('.cart-page-link .cart-count').text(item);

                        form.find('.swatch-wrapper a[data-var-id="'+variant+'"]').attr('data-cart-qty',qty);
                        if(qty == 0){
                          $($this).find('span#AddToCartText').text('ADD TO CART');
                        }
                        $.fancybox.close();
                        $(".as_fload_cart span").css('visibility','visible');
                        $(".loader-check").css("display","none");
              
                      });     
                    },
                    fail : function(){
                    }
                  });
                  //}, 100);
                
              
            }else{
              
              function addItemToCart(variant_id, qty, properties) {
                var data = {
                  "id": variant_id,
                  "quantity": qty,
                  "properties": {
                    "product_id": properties
                  }
                }
                jQuery.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: data,
                  dataType: 'json',
                  success: function() { 
                    console.log('success');
                    jQuery.getJSON('/cart.js', function(cart) {
                      var item = cart.item_count;
                       if(item == 0){
                        $('.cart-page-link .cart-count').addClass('hidden-count');
                      }else{
                        $('.cart-page-link .cart-count').removeClass('hidden-count');
                      }
                      $('.cart-page-link .cart-count').text(item);
                      
                      form.find('.swatch-wrapper a[data-var-id="'+variant+'"]').attr('data-cart-qty',qty);
                      $($this).find('span#AddToCartText').text('UPDATE CART');
                      $.fancybox.close();
                      $(".as_fload_cart span").css('visibility','visible');
                      $(".loader-check").css("display","none");
                    });
                  },
                  error: function() {
                    // ths_val.addClass('cursor_disabled');
                  }
                });
              }
              if(qty > 0){
                console.log('variant',variant)
                console.log('variant',qty)
                addItemToCart(variant, qty, pro_id);
              }
            }
          });
        }else{
          $('.popup_weight').show();
        }
    
  
    return false;
  });




  //product-grid-color-click
  $(document).on('click','.product_options.color_option a.swatch', function(e){
     var this_is = $(this);
      let text = e.target.tagName;
      if(text == 'SPAN'){     
        // $(e.target).parent('a').addClass('hhh');
        $(this).siblings('a.swatch').removeClass('active');
        $(this).addClass('active');
      }else{
        $(this).siblings('a.swatch').removeClass('active');
        $(this).addClass('active');
      }
      if($(this).hasClass('swatch-color')){
         $(this).siblings('a.swatch').find('span').removeClass('active');
         $(this).find('span:first').addClass('active');
      }

     var value = $(this).attr('data-change-value');
    
     var options_size = $(this).parents('.product_options.color_option').attr('data-option-size');
console.log(options_size);
      var final_value = '';
      var last_value = false;
    
      for(var i=0;i<options_size;i++){
        if($(this).parents('.pr-content-left').find('#option'+i).hasClass('color_option')){
          var val = $(this).parents('.pr-content-left').find('#option'+i).find('a.swatch.active').attr('data-change-value');
        }else{
          var val = $(this).parents('.pr-content-left').find('#option'+i).find('select.options_select option:selected').attr('data-title');
        }

        if(final_value){
          final_value = final_value + ' / ' + val;
        }else{
          final_value =  val;
        }

        if(i==options_size-1){
          var last_value = true;
        }
      }
    console.log(final_value)
      if(last_value){
        var var_id = $(this).parents('.pr-content-left').find('.default__var_dropdown select.tetracustomvariant option[data-title="'+final_value+'"]').attr('value');
        var attr_disable = $(this).parents('.pr-content-left').find('.default__var_dropdown select.tetracustomvariant option[data-title="'+final_value+'"]').attr('disabled');
        if(!var_id){
          if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
            $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-5ra53n').attr('disabled','disabled');
            $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-14w70yu').hide();
            $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-14fuadz').hide();
          }else{
            $(this).parents('.pos_abs_grid').find('.css-5ra53n').attr('disabled','disabled');
            $(this).parents('.pos_abs_grid').find('.css-14w70yu').hide();
            $(this).parents('.pos_abs_grid').find('.css-14fuadz').hide();
          }
        }else{
          if(attr_disable == 'disabled'){          
            if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
              $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-5ra53n').attr('disabled','disabled');
              $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-14w70yu').hide();
              $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-14fuadz').hide();
              
            }else{
              $(this).parents('.pos_abs_grid').find('.css-5ra53n').attr('disabled','disabled');
              $(this).parents('.pos_abs_grid').find('.css-14w70yu').hide();
              $(this).parents('.pos_abs_grid').find('.css-14fuadz').hide();
            }
          }else{
            if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
              $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-5ra53n').removeAttr('disabled');
            }else{
              $(this).parents('.pos_abs_grid').find('.css-5ra53n').removeAttr('disabled');
            }
            $(this).parents('.pr-content-left').find('.default__var_dropdown select.tetracustomvariant').val(var_id).trigger('change');
          }
       }
      }
  });
  
  //product-grid-dropdown-change
  $(document).on('change','.pr-content-size.options_dropdown select.options_select', function(e){
    var options_size = $(this).parents('.options_dropdown').attr('data-option-size');
    console.log(options_size)
      var final_value = '';
      var last_value = false;
      for(var i=0;i<options_size;i++){
        if($(this).parents('.pr-content-left').find('#option'+i).hasClass('color_option')){
          var val = $(this).parents('.pr-content-left').find('#option'+i).find('a.swatch.active').attr('data-change-value');
        }else{
          var val = $(this).parents('.pr-content-left').find('#option'+i).find('select.options_select option:selected').attr('data-title');
        }

        if(final_value){
          final_value = final_value + ' / ' + val;
        }else{
          final_value =  val;
        }

        if(i==options_size-1){
          var last_value = true;
        }
      }
      console.log(final_value,'final_value')
      if(last_value){
        var var_id = $(this).parents('.pr-content-left').find('.default__var_dropdown select.tetracustomvariant option[data-title="'+final_value+'"]').attr('value');
        console.log('var_id',var_id);
        var attr_disable = $(this).parents('.pr-content-left').find('.default__var_dropdown select.tetracustomvariant option[data-title="'+final_value+'"]').attr('disabled');
        if(!var_id){
          if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
            $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-5ra53n').attr('disabled','disabled');
            $(this).parents('.pos_abs_grid').find('.variant-sold-out-badge').removeClass('hide');
            $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-14w70yu').hide();
            $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-14fuadz').hide();
          }else{
            $(this).parents('.pos_abs_grid').find('.css-5ra53n').attr('disabled','disabled');
            $(this).parents('.pos_abs_grid').find('.variant-sold-out-badge').removeClass('hide');
            $(this).parents('.pos_abs_grid').find('.css-14w70yu').hide();
            $(this).parents('.pos_abs_grid').find('.css-14fuadz').hide();
          }
        }else{
          if(attr_disable == 'disabled'){
            if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
              $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-5ra53n').attr('disabled','disabled');
              $(this).parents('.pos_abs_grid').find('.variant-sold-out-badge').removeClass('hide');
              $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-14w70yu').hide();
              $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-14fuadz').hide();
            }else{
              $(this).parents('.pos_abs_grid').find('.css-5ra53n').attr('disabled','disabled');
              $(this).parents('.pos_abs_grid').find('.variant-sold-out-badge').removeClass('hide');
              $(this).parents('.pos_abs_grid').find('.css-14w70yu').hide();
              $(this).parents('.pos_abs_grid').find('.css-14fuadz').hide();
            }
          }else{
            if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
              $(this).parents('.pr-content').siblings('.pr-image-weapper').find('.css-5ra53n').removeAttr('disabled');
              $(this).parents('.pos_abs_grid').find('.variant-sold-out-badge').addClass('hide');
            }else{
              $(this).parents('.pos_abs_grid').find('.css-5ra53n').removeAttr('disabled');
              $(this).parents('.pos_abs_grid').find('.variant-sold-out-badge').addClass('hide');
            }
            $(this).parents('.pr-content-left').find('.default__var_dropdown select.tetracustomvariant').val(var_id).trigger('change');
          }
        }
        
      }
  });
});

